// src/features/catalogue/components/SizeSelector.js
import React from "react";

/**
 * Props supported (any one is fine):
 * - sizes: string[]
 * - selectedSize | value : string
 * - onSelect | onChange | setSize : (size) => void
 */
const SizeSelector = ({ sizes = [], selectedSize, value, onSelect, onChange, setSize }) => {
  if (!sizes.length) return null;

  const current = selectedSize ?? value ?? null;
  const handle = onSelect || onChange || setSize || (() => {});

  return (
    <div className="size-toggle" role="tablist" aria-label="Select size">
      {sizes.map((size) => (
        <button
          key={size}
          type="button"
          role="tab"
          aria-selected={current === size}
          className={`size-btn ${current === size ? "active" : ""}`}
          onClick={() => handle(size)}
        >
          {size.charAt(0).toUpperCase() + size.slice(1)}
        </button>
      ))}
    </div>
  );
};

export default SizeSelector;
